import { initApplication } from "@/app";

initApplication();
